import React from 'react';

class BSBreakDown extends React.Component {

	render() {
		var amtPerClick = (parseFloat(this.props.total_spent) / parseFloat(this.props.total_impressions)).toFixed(2);

		return (
			<div className='BSBreakDown-Main'>
				<div className='BSBreakdown-Chunk'>
					<div className='BSBreakdown-Label'>
						Total Spent:
					</div>
					<div className='BSBreakdown-Dollars'>
						{'$' + this.props.total_spent}
					</div>
				</div>
				<div className='BSBreakdown-Chunk'>
					<div className='BSBreakdown-Label'>
						Total Impressions:
					</div>
					<div className='BSBreakdown-Views'>
						{this.props.total_impressions}
					</div>
				</div>
				<div className='BSBreakdown-Chunk'>
					<div className='BSBreakdown-Label'>
						Amount per engagement:
					</div>
					<div className='BSBreakdown-Dollars'>
						{'$' + amtPerClick}
					</div>
				</div>
			</div>

		);
	}
}

export default BSBreakDown;